import React, { useState, useEffect } from "react";
import "../styles/Login.css";
import useAuth from "../hooks/useAuth";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import logo from "../Assests/enfuse-logo.png";
import bgImg from "../Assests/hire.jpg";
import { useSpring, animated } from "react-spring";
import { GoogleLogin } from "@react-oauth/google";
import { message } from "antd";

const URL = process.env.REACT_APP_API_URL;

function Home() {
  const { auth, setAuth, token, setToken } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  // console.log('location: ', location);

  const from = location.state?.from?.pathname || "/";
  // console.log('from: ', from);
  // console.log('typeOf from: ', typeof from);

  const [email, setUserName] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    localStorage.removeItem('hasSeenModal');
    console.log(' useEffect token', token);
    // console.log(' useEffect auth', auth);
  }, [token]);

  // useEffect(() => {
  //   const loadGoogleScript = () => {
  //     const script = document.createElement('script');
  //     script.src = "https://accounts.google.com/gsi/client";
  //     script.async = true;
  //     script.defer = true;
  //     script.onload = () => {
  //       console.log("Google  Identity Services Script loaded!");
  //     }
  //   }
  // }, [])

  const onLogin = async (event) => {
    event.preventDefault();
    const credentials = {
      email,
      password,
    };

    setIsLoading(true);
    axios
      .post(`${URL}/api/login`, credentials)
      .then((response) => {

        setToken(response.data.token);
        setAuth(response.data);
        // sessionStorage.setItem("auth", auth)
        // sessionStorage.setItem("token", token);

        if (response.status === 200 && from.includes('job')) {
          navigate(from, { replace: true });
        }
        else if (response.status === 200) {
          switch (response.data.role) {
            case "Admin":
            case "HR":
            case "HiringManager":
              navigate("/dashboard");
              break;
            case "Applicant":
              navigate("/candidate/candidate");
              break;
            case "Panelist":
              navigate("/feedbacks");
              break;
            default:
              navigate("/");
          }

        } else {
          console.warn("check the response");
        }

      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response) {
          switch (error.response.status) {
            case 400:
              Swal.fire({
                title: "Error!",
                text: "Enter email and password",
                icon: "error",
              });
              break;
            case 404:
              Swal.fire({
                title: "Error!",
                text: "Invalid email",
                icon: "error",
              });
              break;
            case 401:
              Swal.fire({
                title: "Error!",
                text: "Incorrect Password",
                icon: "error",
              });
              break;
            default:
              Swal.fire({
                title: "Error!",
                text: "An unknown error occurred",
                icon: "error",
              });
          }
        }
      });
  };

  const pageAnimation = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 1000 }
  });

  // const handleGoogleLoginSuccess = (credentialResponse) => {
  //   console.log('credential Resopnse: ', credentialResponse);
  //   try {
  //     const jwtResponse = axios.post(`${URL}/api/auth/google`, credentialResponse);

  //     jwtResponse.then(async (response) => {
  //       const { page, token, user } = response.data;
  //       setToken(token);
  //       setAuth(user);
  //       console.log('Redirecting to:', page); // check that page is received

  //       if (page) {
  //         navigate(page); // perform navigation
  //       } else {
  //         message.error('No page returned from server.');
  //       };

  //     }).catch(err => {
  //       console.log('jwtResponse: ', jwtResponse);
  //       console.log('Error from promise catch: ', err);
  //     })

  //   } catch (error) {
  //     console.log('Error occured while signing in : ', error);
  //     message.error('Sorry! An Error Occured while signing you in.')
  //   }

  // }

  // const handleGoogleLoginError = () => {
  //   console.log('Error Occured while logging in with google.');
  // }

  return (
    <animated.div style={pageAnimation}>
      {/* {auth.role ? (
        <h1>Welcome to {auth.role} Dashboard</h1>
      ) : ( */}
      <div>
        <div className='LoginContainer'>
          <div className='formWrapper'>
            <h2 className='customeText'>Welcome</h2>
            <br /><br /><br /><br />
            <img src={logo} alt="Enfuse Logo" />
            <form style={{ marginBottom: '5px' }} onSubmit={onLogin}>
              <div>
                <label>Email</label>
                <input
                  type='text'
                  placeholder='Email'
                  onChange={(e) => setUserName(e.target.value)}
                  value={email}
                />
              </div>
              <div>
                <label>Password</label>
                <input
                  type='password'
                  placeholder='Password'
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                />
              </div>
              <button style={{ marginTop: '-7px' }} type='submit'>Login</button>
            </form>
            {/* <GoogleLogin onSuccess={handleGoogleLoginSuccess} onError={handleGoogleLoginError} /> */}
          </div>
          <div className='bgSec'>
            <img src={bgImg} alt="Background" />
          </div>
        </div>
      </div>
      {/* )} */}
    </animated.div>
  );
}

export default Home;
